import React, { Component } from 'react';

import brazilseedsLogo from '../assets/brazilseedslogogrande.png';

import brizanthaMarandu from '../assets/brizantha-marandu.jpg';
import decumbensBazilisk from '../assets/decumbens-basilisk.jpg';
import humidiculaComum from '../assets/humidicula-comum.jpg';
import humidiculaLlanero from '../assets/humidicula-llanero.jpg';
import humidiculaRuziziensis from '../assets/humidicula-ruziziensis.jpg';
import panicumMassai from '../assets/panicum-massai.jpg';
import panicumMombaca from '../assets/panicum-mombaca.jpg';
import bigBag from '../assets/bigbag.jpg';


class PageProdutos extends Component {
    render() {
        return (
            <div id="body">
                <img src={brazilseedsLogo} id="body-logo" />

                <h1 id="body-h1"> Produtos</h1>

                <div className="div-produtos">
                    <div className="div-produtos-descricao">
                        <h2>BRACHIARIA BRIZANTHA CV. MARANDU</h2>
                        <p>
                            Hábito de Crescimento: Touceira-semiereta.<br />
                            Exigência em Fertilidade de solo: Média a alta.<br />
                            Precipitações: 700 a 1200 mm/ano.<br />
                            Altitude máxima de plantio (metros acima do nível do mar): 2000m.<br />
                            Tolerância ao frio: Média.<br />
                            Tolerância a seca: Média.<br />
                            NÃO TOLERA SOLOS MAL DRENADOS.<br />
                            Profundidade de plantio (cm): 2,0 a 5,0.<br />
                            Densidade de plantio (Pto/VC): 380 PONTOS DE VC.<br />
                            T MS/ha/ano: 16,0.<br />
                            Teor proteína depende da época MS (%): 12,0 /18,0.<br />
                            Digestibilidade: Boa.<br />
                            Utilização: Feno - Pasto – Silagem.<br />
                            Tempo formação pasto desde o plantio: 80 a 100 dias.<br />
                        </p>
                        <br /><br />
                        <p>
                            Manejo: Deve ser feito respeitando a fisiologia da planta e levando em consideração seus pontos de crescimento. Pode ser usado em sistemas rotacionados ou intensivos. Tem ótima resposta a fertilização e calagem. A capacidade de suporte e diretamente proporcional ao bom manejo.
                        </p>
                    </div>
                    {/*<div className="div-produtos-foto">
                <img src={brizanthaMarandu} />
            </div>*/}
                </div>

                <div className="div-produtos">
                    <div className="div-produtos-descricao">
                        <h2>BRACHIARIA DECUMBENS CV. BASILISK</h2>
                        <p>
                            Hábito de Crescimento: Decumbente.<br />
                            Exigência em Fertilidade de solo: Média a baixa.<br />
                            Precipitações: 500 a 1200 mm/ano.<br />
                            Altitude máxima de plantio (metros acima do nível do mar): 2000m.<br />
                            Tolerância ao frio: Média.<br />
                            Tolerância a seca: Boa.<br />
                            ÓTIMO REBROTE COM COMEÇO DAS CHUVAS E PROTEÇÃO DE SOLO PARA ÁREAS COM DECLIVES PRONUNCIADOS.<br />
                            Profundidade de plantio (cm): 2,0 a 3,0.<br />
                            Densidade de plantio (Pto/VC): 380 PONTOS DE VC<br />
                            T MS/ha/ano: 15,0.<br />
                            Teor proteína depende da época MS (%): 6,0 /14,0.<br />
                            Digestibilidade: Boa.<br />
                            Utilização: Feno – Pasto.<br />
                            Tempo formação pasto desde o plantio: 80 a 100 dias.
                        </p>
                        <br /><br />
                        <p>
                            Manejo: Deve ser feito respeitando a fisiologia da planta e levando em consideração seus pontos de crescimento. Por seu crescimento decumbente aceita trabalhar com altura menor que a Marandu. Pode ser usado em sistemas rotacionados, mas é mas recomendada para intensivos. Tem boa resposta a fertilização e calagem. A capacidade de suporte e diretamente proporcional ao bom manejo.
                        </p>
                    </div>
                    {/*
            <div className="div-produtos-foto">
                <img src={decumbensBazilisk} />
            </div>
            */}
                </div>

                <div className="div-produtos">
                    <div className="div-produtos-descricao">
                        <h2>BRACHIARIA BRIZANTHA CV. MG-5 XARAÉS/TOLEDO</h2>
                        <p>
                            Hábito de Crescimento: Touceira ereta.<br />
                            Exigência em Fertilidade de solo: Média a alta.<br />
                            Precipitações: 600 a 1200 mm/ano.<br />
                            Altitude máxima de plantio (metros acima do nível do mar): 2000m.<br />
                            Tolerância ao frio: Media.<br />
                            Tolerância a seca: Boa.<br />
                            EXCELENTE REBROTA<br />
                            Profundidade de plantio (cm): 2,0 a 5,0.<br />
                            Densidade de plantio (Pto/VC): 380 PONTOS DE VC.<br />
                            T MS/ha/ano: 18,0.<br />
                            Teor proteína depende da época MS (%): 14,0 /18,0.<br />
                            Digestibilidade: Media.<br />
                            Utilização: Feno – Pasto.<br />
                            Tempo formação pasto desde o plantio: 80 a 100 dias.
                        </p>
                        <br /><br />
                        <p>
                            Manejo: Deve ser feito respeitando a fisiologia da planta e levando em consideração seus pontos de crescimento. Pode ser usado em sistemas rotacionados ou intensivos. Tem ótima resposta a fertilização e calagem. Quanto adubada fecha o ciclo muito rápido e lignifica rapidamente, por isto, o cuidado e redobrado nessas ocasiões o em verões quentes e de muita chuva, mas bem manejada e uma das melhores opções para fazer volumoso. A capacidade de suporte e diretamente proporcional ao bom manejo.
                        </p>
                    </div>
                    {/*
            <div className="div-produtos-foto">
                <img src={brizanthaMarandu} />
            </div>
            */}
                </div>

                <div className="div-produtos">
                    <div className="div-produtos-descricao">
                        <h2>BRACHIARIA HUMIDICOLA CV COMUM</h2>
                        <p>
                            Hábito de Crescimento: Estolonífero.<br />
                            Exigência em Fertilidade de solo: Média a Baixa.<br />
                            Precipitações: 500 a 1000 mm/ano.<br />
                            Altitude máxima de plantio (metros acima do nível do mar): 800m.<br />
                            Tolerância ao frio: Média.<br />
                            Tolerância a seca: Alta.<br />
                            E O PASTO MAS UTILIZADO EM SOLOS MAL DRENADOS!<br />
                            Profundidade de plantio(cm): 2,0 a 4,0.<br />
                            Densidade de siembra em condições ótimas de siembra (Pto/VC): 280 PONTOS DE VC.<br />
                            T MS/ha/ano: 8,00 a 11,00.<br />
                            Teor proteína depende da época MS (%): 6 a 9.<br />
                            Digestibilidade: Boa.<br />
                            Utilização: Pasto.<br />
                            Tempo formação pasto desde o plantio: 120 a 150 dias.<br />
                        </p>
                        <br /><br />
                        <p>
                            Manejo: Deve ser feito respeitando a fisiologia da planta e levando em consideração seus pontos de crescimento. Pode ser usado em sistemas intensivos. Tem baixa resposta se comparada com outras brachiarias a fertilização e calagem mas responde. Se diz que toda fazenda “deve ter” um pasto de humidicola. A capacidade de suporte e diretamente proporcional ao bom manejo.
                        </p>
                    </div>
                    {/*
            <div className="div-produtos-foto">
                <img src={humidiculaComum} />
            </div>
            */}
                </div>

                <div className="div-produtos">
                    <div className="div-produtos-descricao">
                        <h2>BRACHIARIA HUMIDICOLA CV LLANERO</h2>
                        <p>
                            Hábito de Crescimento: Estolonífero.<br />
                            Exigência em Fertilidade de solo: Média a Baixa.<br />
                            Precipitações: 500 a 1000 mm/ano.<br />
                            Altitude máxima de plantio (metros acima do nível do mar): 800m.<br />
                            Tolerância ao frio: Média.<br />
                            Tolerância a seca: Alta.<br />
                            EXCELENTE OPÇÃO PARA CAVALOS E CRIA!<br />
                            Profundidade de siembra(cm): 2,0 a 4,0.<br />
                            Densidade de siembra em condições ótimas de siembra (Pto/VC): 400 PONTOS DE VC.<br />
                            T MS/ha/ano: 12,00 a 16,00.<br />
                            Teor proteína depende da época MS (%): 10 a 12.<br />
                            Digestibilidade: Boa.<br />
                            Utilização: Pasto, Feno para cavalos.<br />
                            Tempo formação pasto desde o plantio: 150 a 180 dias.
                        </p>
                        <br /><br />
                        <p>
                            Manejo: Deve ser feito respeitando a fisiologia da planta e levando em consideração seus pontos de crescimento. Pode ser usado em sistemas intensivos. Tem boa resposta a fertilização e calagem. Por ter um crescimento estolonífero aguenta trabalhar um pastoreo mas agressivo, Excelente opção para solos de baixa fertilidade. A capacidade de suporte e diretamente proporcional ao bom manejo.
                        </p>
                    </div>
                    {/*
            <div className="div-produtos-foto">
                <img src={humidiculaLlanero} />
            </div>
            */}
                </div>

                <div className="div-produtos">
                    <div className="div-produtos-descricao">
                        <h2>BRACHIARIA RUZIZIENSIS CV B.RUZIZIENSIS</h2>
                        <p>
                            Hábito de Crescimento: Touceira decumbente.<br />
                            Exigência em Fertilidade de solo: Média.<br />
                            Precipitações: 500 a 1000 mm/ano.<br />
                            Altitude máxima de plantio (metros acima do nível do mar): 2000m.<br />
                            Tolerância ao Frio: Média.<br />
                            Tolerância a seca: Media.<br />
                            UNICA CULTIVAR COMPROBADA CIENTIFICAMENTE QUE TRAZ BENEFICIOS A INTEGRAÇÃO AGRICULTURA PECURIA!<br />
                            Profundidade de plantio (cm): 2, 0 a 5, 0.<br />
                            Densidade de siembra em condições ótimas de plantio (Pto/VC): 400 PONTOS DE VC (PARA INTEGRAÇAO 200 PUNTOS DE VC).<br />
                            T MS/ha/ano: 16, 00 a 19, 00.<br />
                            Teor proteína depende da época MS (%): 10 a 12.<br />
                            Digestibilidade: Boa.<br />
                            Utilização: Pasto, Feno.<br />
                            Tempo formação pasto desde o plantio: 90 a 120 dias.
                        </p>
                        <br /><br />
                        <p>
                            Manejo: Deve ser feito respeitando a fisiologia da planta e levando em consideração seus pontos de crescimento. Pode ser usado em sistemas intensivos. Tem boa resposta a fertilização e calagem. Por ter um crescimento em toucerias decumbente tem uma excelente cobertura de solos, fora integração e um pasto muito bem aceito pelo animal. A capacidade de suporte e diretamente proporcional ao bom manejo.
                        </p>
                    </div>
                    {/*
            <div className="div-produtos-foto">
                <img src={humidiculaRuziziensis} />
            </div>
            */}
                </div>

                <div className="div-produtos">
                    <div className="div-produtos-descricao">
                        <h2>PANICUM MAXIMUM CV MASSAI</h2>
                        <p>
                            Hábito de Crescimento: Touceira.<br />
                            Exigência em Fertilidade de solo: Média.<br />
                            Precipitações: acima de 600 mm/ano.<br />
                            Altitude máxima de plantio (metros acima do nível do mar): 2000m.<br />
                            Tolerância ao Frio: Média.<br />
                            Tolerância a seca: Boa.<br />
                            O MELHOR CULTIVAR LANÇADO NOS ULTIMOS ANOS!<br />
                            Profundidade de plantio (cm): 2, 0 a 4, 0.<br />
                            Densidade de plantio em condições ótimas de plantio (Pto/VC): 380 PONTOS DE VC.<br />
                            T MS/ha/ano: 18, 00 a 22, 00.<br />
                            Teor proteína depende da época MS (%): 16 a 18.<br />
                            Digestibilidade: Muito Boa.<br />
                            Utilização: Pasto, Feno, Rotacionado.<br />
                            Tempo formação pasto desde o plantio: 90 a 100 dias.
                        </p>
                        <br /><br />
                        <p>
                            Manejo: Deve ser feito respeitando a fisiologia da planta e levando em consideração seus pontos de crescimento. Pode ser usado em sistemas intensivos e também em rotacionados. Tem excelente resposta a fertilização e calagem. Por ter um crescimento entouceirado mas um excelente perfilhamento e rebrota basal. A capacidade de suporte e diretamente proporcional ao bom manejo.
                        </p>
                    </div>
                    {/*
            <div className="div-produtos-foto">
                <img src={panicumMassai} />
            </div>
            */}
                </div>

                <div className="div-produtos">
                    <div className="div-produtos-descricao">
                        <h2>PANICUM MAXIMUM CV MOMBAÇA</h2>
                        <p>
                            Hábito de Crescimento: Touceira, cespitosa.<br />
                            Exigência em Fertilidade de solo: Alta.<br />
                            Precipitações: acima de 800 mm/ano.<br />
                            Altitude máxima de plantio (metros acima do nível do mar): 1200m.<br />
                            Tolerância ao frio: Média.<br />
                            Tolerância a seca: Média.<br />
                            BOA OPÇÃO PARA ROTACIONADO COM FERTILIZAÇÃO!<br />
                            Profundidade de plantio (cm): 2,0 a 4,0.<br />
                            Densidade de plantio em condições ótimas de plantio (Pto/VC): 300 PONTOS DE VC.<br />
                            T MS/ha/ano: 20,00 a 26,00.<br />
                            Teor proteína depende da época MS (%): 16 a 18.<br />
                            Digestibilidade: Boa.<br />
                            Utilização: Pasto, Rotacionado.<br />
                            Tempo formação pasto desde o plantio: 90 a 100 dias.
                        </p>
                        <br /><br />
                        <p>
                            Manejo: Deve ser feito respeitando a fisiologia da planta e levando em consideração seus pontos de crescimento. Pode ser usado em sistemas intensivos e também em rotacionados. Tem excelente resposta a fertilização e calagem. Por ter um crescimento entouceirado mas um excelente perfilhamento e rebrota basal. A capacidade de suporte e diretamente proporcional ao bom manejo.
                        </p>
                    </div>
                    {/*
            <div className="div-produtos-foto">
                <img src={panicumMombaca} />
            </div>
            */}
                </div>

            </div>
        );
    }
}

export default PageProdutos;



// WEBPACK FOOTER //
// ./src/Pages/PageProdutos.js